export const getCookie = (name) => {
  // eslint-disable-next-line
  const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'))
  return matches ? decodeURIComponent(matches[1]) : undefined
}

export const setCookie = (name, value, options: {
  path?: string
  expires?: any
} = {}) => {
  options = {
    path: '/',
    ...options
  }

  if (options?.expires) {
    options.expires = new Date(options?.expires).toUTCString()
  }

  let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`

  for (const optionKey in options) {
    updatedCookie += '; ' + optionKey
    const optionValue = options[optionKey]
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue
    }
  }
  document.cookie = updatedCookie
}

export const isTopQuestionnaireRequestCookie = (state) => {
  const cookie = state.cookie.questionnaireRequest
  const cookieExpire = cookie.expire
  const cookieName = cookie.storageKey
  const cookieValue = getCookie(cookieName)
  if (cookieValue) {
    return false
  }
  const timestamp = new Date().getTime()
  setCookie(cookieName, timestamp, {
    expires: timestamp + cookieExpire
  })
  return true
}

